import { Component, Input, OnChanges } from '@angular/core';
import { StreamService } from '../services/stream.service';

@Component({
    selector: 'topic-menu-button',
    styles: [`
        .selected-menu-item {
            background: #D7D7D7;
        }

        button {
            text-align: left;
            width: 100%;
            font-size: 18px;
            padding-left: 60px;
            font-size: 15px;
            /*flex: 1;*/
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `],
    template: `
        <button mat-button
                [routerLink]="['/digest', 'categories', categoryId, 'topics', topic?.id]"
                [ngClass]="{'selected-menu-item': selectedItem === categoryId + '-' + topic?.id }">
            <div style="display: inline-block; width: 15px;"><new-indicator *ngIf="hasNew"></new-indicator></div> {{topic?.title}}
        </button>
    `
})
export class TopicMenuButtonComponent implements OnChanges {
    @Input() categoryId: string;
    @Input() selectedItem: string;
    @Input() topic;
    @Input() subscription;
    hasNew: boolean;

    constructor(private streamService: StreamService) {}

    ngOnChanges(): void {
        this.hasNew = this.topic && this.subscription && this.streamService.topicHasNewContent(this.topic, this.subscription);
    }
}
